<div class="flex flex-wrap items-end">
  <app-tariff-title [tariffId]="me().tariff?.uid"></app-tariff-title>
  <div class="title text-2xl credits__count" [innerHTML]="(me().duration || 0) | number: '1.0-0'"></div>
</div>
